<template>
  <div>
    <validation-observer ref="customFieldRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <validation-provider
              #default="{ errors }"
              name="custom-type"
              rules="required"
            >
              <b-form-group
                :label="$t('DEBTIA_CUSTOM_FIELDS')"
                label-for="custom-type"
              >
                <v-select
                  v-model="customType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="customTypeOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="custom-type"
                  multiple
                  @input="assignField"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col
            v-for="(data,index) in customInputs"
            :key="index"
            sm="12"
          >
            <div :id="'div-wrapper-'+data.argIndex">
              <validation-provider
                #default="{ errors }"
                :name="$t(data.label)"
                :rules="`required|${data.rule}`"
              >
                <b-form-group
                  :label="$t(data.label)"
                  :label-for="`email-template-${data.argIndex}`"
                >

                  <v-select
                    v-if="data.type !== 'select'"
                    v-model="data.mappedValue"
                    :disabled="busy"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="data.dropDownVars"
                    :reduce="val => val.value"
                    :clearable="false"
                    :input-id="'email-template-'+data.argIndex"
                    :class="'email-template-'+data.argIndex"
                    @input="changeVariable($event, data.argIndex)"
                  >
                    <template
                      slot="option"
                      slot-scope="option"
                    >
                      <div :class="assignClass(option.value) ? 'autofik' : ''">
                        {{ option.label }}
                      </div>
                    </template>
                  </v-select>
                  <v-select
                    v-if="data.type === 'select'"
                    v-model="data.customVal"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="data.options.length > 0 ? data.options : airportDropdown"
                    :reduce="val => val.value"
                    :clearable="false"
                    :input-id="`input-${data.value}`"
                  />

                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>

              </validation-provider>
              <b-row
                :id="'date-'+data.argIndex"
                class="showdates"
              >
                <b-col md="12">
                  <b-form-group
                    label="Select number of days"
                    label-for="email_template"
                  >
                    <b-form-input
                      :id="'noOfDays-'+data.value"
                      v-model="data.functional_value"
                      type="number"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row
                :id="'run-date-'+data.argIndex"
                class="showdates"
              >
                <b-col md="12">
                  <b-form-group
                    label="Select Module"
                    :label-for="'prev-module-dropdown-'+data.value"
                  >
                    <v-select
                      v-model="data.functional_value"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="prevModuleOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      :input-id="'prev-module-dropdown-'+data.value"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row
                v-if="data.type !== 'select' && data.manualVal === true"
                class="customFields"
              >
                <b-col md="12">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(data.label)"
                    :rules="getRules(data.rule, data.type)"
                  >
                    <b-form-group
                      :label="'Enter Manual value for '+$t(data.label)"
                      :label-for="`input-${data.value}`"
                    >
                      <b-form-input
                        v-if="(data.type === 'string' || data.type === 'number') && data.manualVal === true"
                        :id="`input-${data.value}`"
                        v-model="data.customVal"
                        :state="errors.length > 0 ? false:null"
                        :placeholder="$t(data.label)"
                        :type="data.type === 'number' ? 'number' : 'text'"
                      />

                      <b-form-radio-group
                        v-if="data.type === 'boolean' && data.manualVal === true"
                        v-model="data.customVal"
                        :input-id="`input-${data.value}`"
                        :options="radioOptions"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                        class="demo-inline-spacing radiocustomvariables"
                      />

                      <b-input-group
                        v-if="data.type === 'date' && data.manualVal === true"
                      >
                        <cleave
                          :id="`input-${data.value}`"
                          v-model="data.dacustomVal"
                          class="form-control"
                          :raw="false"
                          :options="options.date"
                          placeholder="DD-MM-YYYY"
                          @input="validateDate(0, data.dacustomVal, index)"
                        />
                        <b-input-group-append>
                          <b-form-datepicker
                            :id="`input-${data.value}`"
                            v-model="data.customVal"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                            trim
                            button-only
                            right
                            size="sm"
                            @input="validateDate(1, data.customVal, index)"
                          />
                        </b-input-group-append>
                      </b-input-group>

                      <b-form-timepicker
                        v-if="data.type === 'time' && data.manualVal === true"
                        :id="`input-${data.value}`"
                        v-model="data.customVal"
                        class="timepicker"
                      />

                      <b-form-textarea
                        v-if="data.type === 'multiline string' && data.manualVal === true"
                        :id="`input-${data.value}`"
                        v-model="data.customVal"
                        :placeholder="data.label"
                        rows="3"
                      />
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <label
                      :id="'dateerror-'+index"
                      style="color: red; display:none;"
                    >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                  </validation-provider>
                </b-col>

              </b-row>
            </div>
          </b-col>
          <b-col
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="submitData"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTextarea,
  BFormTimepicker, BInputGroupAppend, BInputGroup,
  // BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import Cleave from 'vue-cleave-component'
import { required, integer } from '@validations'
import constants from '@/app-configs/constants'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    // BInputGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTextarea,
    BFormTimepicker,
    BInputGroupAppend,
    BInputGroup,
    Cleave,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      integer,
      customType: '',
      days: '',
      customTypeOptions: [],
      customInputs: [],
      customFieldData: [],
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
      airportDropdown: [],
      templateVariableOptions: [],
      specialOptions: [
        { name: 'dato_felt', label: 'Select number of days after letter generation' },
        { name: 'auto_fik', label: '' },
        { name: 'debtia.recepient_name', label: 'Enter recepient name.' },
        { name: 'debtia.recepient_contact_person', label: 'Enter recepient contact person' },
        { name: 'debtia.recepient_road_name', label: 'Enter recepient address road name' },
        { name: 'debtia.recepient_house_number', label: 'Enter recepient house number' },
        { name: 'debtia.recepient_zipcode', label: 'Enter recepient zipcode' },
        { name: 'debtia.recepient_city', label: 'Enter recepient city' },
        { name: 'debtia.recepient_country', label: 'Enter recepient country' },
        { name: 'debtia.recepient_place', label: 'Enter recepient place' },
        { name: 'module_run_date', label: 'Module Run Date' },
      ],
      prevModuleOptions: [],
      busy: false,
      emailvariables: {},
      errorMsg: false,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
    }
  },
  created() {
    this.attachVariables()
    this.getCustomVars()
  },
  methods: {
    getRules(rules, type) {
      let validationRules = ''
      if (type === 'date') {
        validationRules = `required|${rules}|datePattern`
      } else {
        validationRules = `required|${rules}`
      }
      return validationRules
    },
    validateDate(type, value, index) {
      if (type === 0) {
        this.customInputs[index].customVal = this.$FormformattedDate(value)
      } else {
        this.customInputs[index].dacustomVal = this.$DAformattedDate(value)
      }
    },
    async getCustomVars() {
      try {
        const vars = await axios.get('/get-custom-var-dropdown')
        if (vars.data.status === 200) {
          this.customTypeOptions = vars.data.data.variables.map((e, i) => ({
            ...e,
            label: this.$t(e.label),
            argIndex: i,
            manualVal: false,
            dropDownVars: this.templateVariableOptions.filter((el, index) => index === 0 || el.varType === e.type),
          }))
          this.airportDropdown.push(...vars.data.data.options)
        }
      } catch (e) {
        console.log(e)
      }
    },
    assignField(variable) {
      this.customInputs = []
      const x = variable.map(e => this.customTypeOptions.filter(ele => ele.value === e))

      x.forEach(e => {
        if (!e[0].dacustomVal) e[0].dacustomVal = null
        this.customInputs.push(...e)
      })
    },
    submitData() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 15,
        module_order: 1,
        custom_variables: this.customInputs,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      this.$refs.customFieldRules.validate().then(success => {
        if (success) {
          const url = '/process/module/add'
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              this.customType = ''
              this.days = ''
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeCustomDataModal', returnObj)
            }
          })
        }
      })
    },
    async attachVariables() {
      this.templateVariableOptions = [
        { label: 'Enter Manual Value', value: 'manual.entry', varType: 'string' },
        { label: 'clients.name', value: 'clients.name', varType: 'string' },
        { label: 'clients.roadname', value: 'clients.roadname', varType: 'string' },
        { label: 'clients.house_no', value: 'clients.house_no', varType: 'string' },
        { label: 'clients.zipcode', value: 'clients.zipcode', varType: 'string' },
        { label: 'clients.city', value: 'clients.city', varType: 'string' },
        { label: 'clients.cvr', value: 'clients.cvr', varType: 'string' },
        { label: 'clients.email', value: 'clients.email', varType: 'string' },
        { label: 'debtors.name', value: 'debtors.name', varType: 'string' },
        { label: 'debtors.phone', value: 'debtors.phone', varType: 'string' },
        { label: 'debtors.email', value: 'debtors.email', varType: 'string' },
        { label: 'debtors.contact_person', value: 'debtors.contact_person', varType: 'string' },
        { label: 'debtor_addresses.road_name', value: 'debtor_addresses.road_name', varType: 'string' },
        { label: 'debtor_addresses.house_no', value: 'debtor_addresses.house_no', varType: 'string' },
        { label: 'debtor_addresses.zip_code', value: 'debtor_addresses.zip_code', varType: 'string' },
        { label: 'debtor_addresses.city', value: 'debtor_addresses.city', varType: 'string' },
        { label: 'debt_case_info.payment_amount', value: 'debt_case_info.payment_amount', varType: 'string' },
        { label: 'debt_case_info.interest_rate_percentage', value: 'debt_case_info.interest_rate_percentage', varType: 'string' },
        { label: 'debt_case_info.reminder_fee', value: 'debt_case_info.reminder_fee', varType: 'string' },
        { label: 'debt_case_info.paid_amount', value: 'debt_case_info.paid_amount', varType: 'string' },
        { label: 'debt_case_info.credit_note_amount', value: 'debt_case_info.credit_note_amount', varType: 'string' },
        { label: 'debt_case_info.total_amount', value: 'debt_case_info.total_amount', varType: 'string' },
        { label: 'debt_cases.id', value: 'debt_cases.id', varType: 'string' },
        { label: 'debtor.co', value: 'debtor.co', varType: 'string' },
        { label: 'debtor.addresses.place', value: 'debtor.addresses.place', varType: 'string' },
        { label: 'debt_case_info.principal', value: 'debt_case_info.principal', varType: 'string' },
        { label: 'debt_case_info.remainingDebt', value: 'debt_case_info.remainingDebt', varType: 'string' },
        { label: 'debt_case_info.principal_rest', value: 'debt_case_info.principal_rest', varType: 'string' },
        { label: 'debt_case_info.interest_rest', value: 'debt_case_info.interest_rest', varType: 'string' },
        { label: 'debt_case_info.collection_fee_rest', value: 'debt_case_info.collection_fee_rest', varType: 'string' },
        { label: 'debt_case_info.compensation_cost_rest', value: 'debt_case_info.compensation_cost_rest', varType: 'string' },
        { label: 'debt_case_info.reminder_fee_rest', value: 'debt_case_info.reminder_fee_rest', varType: 'string' },
        { label: 'debt_case_info.collection_cost_rest', value: 'debt_case_info.collection_cost_rest', varType: 'string' },
        { label: 'debt_case_info.salary_rest', value: 'debt_case_info.salary_rest', varType: 'string' },
        { label: 'debt_case_info.total_rest', value: 'debt_case_info.total_rest', varType: 'string' },
        { label: 'Await Days', value: 'await.days', varType: 'string' },
        { label: 'Link', value: 'debtia.link', varType: 'string' },
        /* { label: 'Bookingnumber', value: 'custom_var.bookingnumber', varType: 'string' },
        { label: 'Flightnumber', value: 'custom_var.flightnumber', varType: 'string' },
        { label: 'Incident Cause', value: 'custom_var.incident_cause', varType: 'select' },
        { label: 'Incident Description', value: 'custom_var.incident_description', varType: 'select' },
        { label: 'Actual Arrival Date', value: 'custom_var.actual_arrival_date', varType: 'date' },
        { label: 'Actual Arrival Time', value: 'custom_var.actual_arrival_time', varType: 'time' },
        { label: 'Planned Departure Date', value: 'custom_var.planned_arrival_date', varType: 'date' },
        { label: 'Planned Arrival Time', value: 'custom_var.planned_arrival_time', varType: 'time' },
        { label: 'Debtor Case ID', value: 'custom_var.debtor_case_id', varType: 'string' },
        { label: 'Starting Airport', value: 'custom_var.starting_airport', varType: 'select' },
        { label: 'Arrival Airport', value: 'custom_var.arrival_airport', varType: 'select' },
        { label: 'Fellow Passenger Names', value: 'custom_var.fellow_passenger_names', varType: 'multiline string' },
        { label: 'IATA', value: 'debtor_customvar.IATA', varType: 'string' },
        { label: 'E/mail', value: 'debtor_customvar.email', varType: 'string' },
        { label: 'Requirements Departure airport', value: 'custom_var.requirements_dept_airport', varType: 'select' },
        { label: 'Requirements Arrival airport', value: 'custom_var.requirements_arrival_airport', varType: 'select' },
        { label: 'Distance in KM', value: 'custom_var.distance_in_km', varType: 'string' },
        { label: 'Number of passengers', value: 'custom_var.co_passengers_number', varType: 'string' },
        { label: 'Delay', value: 'custom_var.delay', varType: 'string' },
        { label: 'Letter Demand Date', value: 'custom_var.letter_demand_date', varType: 'date' },
        { label: 'SimplyID', value: 'custom_var.simplyid', varType: 'string' },
        { label: 'Alias', value: 'debtor_customvar.alias', varType: 'string' },
        { label: 'Concilio ID no', value: 'debtor_customvar.concilio_id_no', varType: 'string' }, */
        { label: 'dato felt', value: 'dato_felt', varType: 'date' },
        { label: 'Auto FIK', value: 'auto_fik', varType: 'string' },
        { label: 'Recepient Name', value: 'debtia.recepient_name', varType: 'string' },
        { label: 'Recepient Contact Person', value: 'debtia.recepient_contact_person', varType: 'string' },
        { label: 'Recepient Address Road Name', value: 'debtia.recepient_road_name', varType: 'string' },
        { label: 'Recepient Address House Number', value: 'debtia.recepient_house_number', varType: 'string' },
        { label: 'Recepient Address Zipcode', value: 'debtia.recepient_zipcode', varType: 'string' },
        { label: 'Recepient Address City', value: 'debtia.recepient_city', varType: 'string' },
        { label: 'Recepient Address Country', value: 'debtia.recepient_country', varType: 'string' },
        { label: 'Recepient Address Place', value: 'debtia.recepient_place', varType: 'string' },
        { label: 'Module Run Date', value: 'module_run_date', varType: 'date' },
        // { label: 'informed more than 14 days prior', value: 'custom_var.inform_prior', varType: 'boolean' },
        // { label: 'Necessary Info Uploaded?', value: 'custom_var.info_uploaded', varType: 'boolean' },
      ]

      await axios.get(`${constants.serverBaseUrl}/api/v2/debtiaapp/process/get-custom-variables`).then(response => {
        if (response.status) {
          const index = this.templateVariableOptions.length - this.specialOptions.length
          this.templateVariableOptions.splice(index, 0, ...response.data.data)
        }
      })

      await axios.get('/process/get-statement-vars').then(response => {
        if (response.status) {
          const index = this.templateVariableOptions.length - this.specialOptions.length
          this.templateVariableOptions.splice(index, 0, ...response.data.data)
        }
      })
    },
    changeVariable(event, variable) {
      this.$el.querySelector(`.email-template-${variable}`).classList.remove('inputErrorClass')
      if (event === 'dato_felt') {
        document.getElementById(`div-wrapper-${variable}`).classList.add('div-wrapper')
        document.getElementById(`run-date-${variable}`).style.display = 'none'
        document.getElementById(`date-${variable}`).style.display = 'block'
        this.customTypeOptions[variable].manualVal = false
        this.customTypeOptions[variable].customVal = 'dato_felt'
      } else if (event === 'module_run_date') {
        if (this.prevModuleOptions.length === 0) {
          this.getPreviousModules()
        }
        document.getElementById(`div-wrapper-${variable}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable}`).style.display = 'none'
        document.getElementById(`run-date-${variable}`).style.display = 'block'
        this.customTypeOptions[variable].manualVal = false
        this.customTypeOptions[variable].customVal = 'module_run_date'
      } else {
        if (event === 'manual.entry') {
          this.customTypeOptions[variable].manualVal = true
          this.customTypeOptions[variable].customVal = null
          document.getElementById(`div-wrapper-${variable}`).classList.add('div-wrapper')
        } else {
          const customVar = this.templateVariableOptions.filter(e => e.value === event && e.custom_variable === true)
          this.customTypeOptions[variable].manualVal = false
          document.getElementById(`div-wrapper-${variable}`).classList.remove('div-wrapper')
          this.customTypeOptions[variable].customVal = customVar.length > 0 ? 'custom_variable' : event
          if (customVar.length > 0) {
            this.customTypeOptions[variable].functional_value = event
          }
        }
        document.getElementById(`date-${variable}`).style.display = 'none'
        document.getElementById(`run-date-${variable}`).style.display = 'none'
      }
    },
    async getPreviousModules() {
      const processID = this.$route.params.id
      await axios.get(`/process/get-previous-modules/${Number(processID)}`).then(response => {
        if (response.status === 200) {
          this.prevModuleOptions.push(...response.data.data)
        }
      }).catch(error => console.log(error))
    },
    assignClass(field) {
      let exists = false
      const entry = this.specialOptions.filter(e => e.name === field)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }

  .emailSubmitBtn {
    width: 100%;
    margin-bottom: 10px;
  }

  #fieldserror {
    color: red;
  }

  .inputErrorClassField{
    border-color: red !important;
  }

  .showdates {
    display: none;
    margin-top: 10px;
  }

  .customFields {
    margin-top: 10px;
  }

  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }

  div.div-wrapper {
    border: 1px solid #d8d6de;
    border-radius: 5px;
    padding: 10px 10px 5px 10px;
    margin-bottom: 6px;
  }
</style>
